import React from 'react';
import { css } from 'styled-components';
import Box from '@sizeid/commons/components/Box';
import { media } from '@sizeid/commons/utils/styles';
import { BoxProps } from '@sizeid/commons/components/Box/types';
import { CSSInterpolation } from '@sizeid/commons/types';

import theme from 'themes/default';

const style = (props: BoxProps): CSSInterpolation =>
  props.contentPadding
    ? css`
        ${props.css};
        padding: 20px 15px;

        ${media.moreThan('sm')`
          padding: 40px;
        `};
      `
    : props.css ?? css``;

const WhiteBox: React.FC<BoxProps & { contentPadding?: boolean }> = props => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { children, css, ...boxProps } = props;
  return (
    <Box
      background={theme.colors.white}
      border={`1px solid ${theme.colors.black.light[50]}`}
      borderRadius={theme.sizes.borderRadius}
      boxShadow={theme.outlines.shadow.default}
      css={style(props)}
      {...boxProps}
    >
      {props.children || null}
    </Box>
  );
};

export default WhiteBox;
